import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { api, get } from "@config";

import Input from "../../theme/form/input/input";
import { setPersonDoc } from "./actions";
import { setLoading } from "../../theme/actions";

import { validateCPF } from "./validate-cpf";
import { validateCNPJ } from "./validate-cnpj";

import ImportCNPJ from "../../../_components/ImportCNPJ";

import styled from "styled-components";
import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
} from "../base-person/actions";
import { setCNAE, setFancyName } from "../company-data/actions";
import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "../address-component/actions";

const CNPJWrapper = styled.div`
  display: flex;
`;

class PersonDocument extends Component {
  constructor(props) {
    super(props);
    this.state = { docIsValid: true };
  }

  validateDoc() {
    const { type } = this.props;

    const docIsValid = !type
      ? validateCPF(this.props.doc)
      : validateCNPJ(this.props.doc);

    document
      .querySelector("[data-doc-valid]")
      .setAttribute("data-doc-valid", docIsValid);
    this.setState({
      ...this,
      docIsValid,
    });
    if (docIsValid) {
      this.searchDoc();
    }
  }

  searchDoc() {
    this.props.setLoading(true);
    const { doc, type } = this.props;
    const url = `${api.searchCmpanyByCnpj}=${doc}`;
    const payload = (data) => {
      document
        .querySelector("[data-doc-valid]")
        .setAttribute("data-doc-valid", !data.status);

      document
        .querySelector("[data-doc-valid]")
        .setAttribute("already-exists", data.status);

      this.props.setLoading(false);
    };
    get(url, payload);
  }
  setValidateDoc() {
    this.searchDoc();
  }
  render() {
    const isCompany = ![0, 3].includes(this.props.type);
    const handleSuccess = (data) => {
      this.props.setBasePersonName(data.name);
      this.props.setBasePersonEmail(data.email);
      this.props.setBasePersonPhoneNumber(data.phone_number);
      this.props.setFancyName(data.company.fancy_name);
      this.props.setPostalCode(data.address.postal_code);
      this.props.setStreetNumber(data.address.street_number);
      this.props.setComplement(data.address.complement);
      this.props.setStateLocation({
        id: data.address.state_location,
        value: data.address.state_location,
        label: data.address.state_location_uf,
      });
      this.props.setCityLocation({
        id: data.address.city_location,
        value: data.address.city_location,
        label: data.address.city_location_name,
      });
      this.props.setStreet(data.address.street);
      this.props.setDistrict(data.address.district);
    };
    return (
      <div
        data-doc-valid={this.state.docIsValid}
        id="person-doc"
        className={`my-2 ${this.state.docIsValid ? "" : "has-error"}`}
      >
        <p htmlFor="">
          {this.props.required ? "*" : ""}
          {isCompany ? "CNPJ" : "CPF"}
        </p>
        <CNPJWrapper>
          {" "}
          <Input
            id="person-input-doc"
            onChange={(e) => {
              this.props.setPersonDoc(e);
              if ((isCompany && e == 14) || (!isCompany && e == 11)) {
                setTimeout(() => {
                  this.validateDoc();
                }, 300);
              }
            }}
            value={this.props.doc}
            mask={isCompany ? "99.999.999/9999-99" : "999.999.999-99"}
            margin
            placeholder={isCompany ? "CNPJ" : "CPF"}
          />
          {isCompany ? (
            <ImportCNPJ onSuccess={handleSuccess} cnpj={this.props.doc} />
          ) : (
            <span />
          )}
        </CNPJWrapper>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  type: state.personType,
  doc: state.personDoc,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPersonDoc,
      setLoading,
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,
      setCNAE,
      setFancyName,
      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(PersonDocument);
export { validateCPF, validateCNPJ };



// WEBPACK FOOTER //
// ./src/components/parts/document-component/index.jsx